<template>
  <BaseTableView
    :class="$vuetify.breakpoint.lgAndUp ? 'table' : ''"
    :head="headerTable"
    list-view="lgAndUp"
    card-view="mdAndDown"
  >
    <template v-slot:header>
      <tr>
        <th class="name">
          {{ localStorage.translations.pages['setting-roles'].tables.nazvanie }}
        </th>
        <template v-for="(item, itemKey) in rolesConfig">
          <th v-for="(param, paramKey) in item.params" :key="itemKey + '_' + paramKey" class="role">
            <v-tooltip bottom color="#2C2C2C">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" class="module f14">
                  {{ item.title + ' - ' + param.name }}
                </span>
              </template>
              <span>{{ item.title + ' - ' + param.name }}</span>
            </v-tooltip>
          </th>
        </template>
        <th></th>
      </tr>
    </template>
    <RolesTableItem
      v-for="item in rolesData"
      :key="item.id"
      :item="item"
      :tableItems="rolesConfig"
    />
  </BaseTableView>
</template>

<script>
import RolesTableItem from 'components/setting/roles/RolesTableItem'

export default {
  name: 'RolesTable',
  props: ['rolesData', 'abilitiesData', 'rolesConfig'],
  components: { RolesTableItem },
  computed: {
    headerTable() {
      let result = [{text: this.localStorage.translations.pages['setting-roles'].tables['nazvanie']}]
      for (let i in this.rolesConfig) {
        for (let p in this.rolesConfig[i].params) {
          result.push({
            text: this.rolesConfig[i].title + ' - ' + this.rolesConfig[i].params[p].name
          })
        }
      }
      result.push({active: true})
      return result
    }
  },
  data: () => ({
    dialog: false,
    search: '',
  }),
}
</script>

<style lang="scss">
.table {
  th {
    font-weight: 500;
    color: #2c2c2c !important;
    cursor: default;
    
    &.name {
      padding-left: 25px;
      width: 10%;
    }
    
    &.role {
      padding: 0;
      border-right: 1px solid #dbdbdb;
      
      .module {
        height: 150px;
        padding: 5px 7px;
        writing-mode: vertical-rl;
        transform: rotate(-180deg);
        white-space: nowrap;
        text-overflow: ellipsis;
        display: block;
        overflow: hidden;
        
        font-size: 12px;
        line-height: 14px;
        margin: 0;
      }
    }
    &:first-child {
      border-right: 1px solid #dbdbdb;
    }
    &:last-child {
      border-left: 1px solid #dbdbdb;
    }
  }
  
  td {
    &.role {
      border-right: 1px solid #dbdbdb;
    }
    
    &:last-child {
      width: 100%;
    }
    &:first-child {
      border-right: 1px solid #dbdbdb;
    }
  }
  
  
  .access_for_table {
    width: max-content;
    display: block;
    overflow: auto;
    border-radius: 0px;
    
    thead {
      position: relative;
      border-radius: 0px;
      
      th {
        height: 150px;
        width: 30px;
        padding: 0 !important;
        border-left: 1px solid #dbdbdb;
        font-size: 12px;
        line-height: 14px;
        font-weight: normal;
        
        &:last-child {
          border-right: 1px solid #dbdbdb;
        }
        
        .module {
          height: 150px;
          padding: 5px 7px;
          writing-mode: vertical-rl;
          transform: rotate(-180deg);
          white-space: nowrap;
          text-overflow: ellipsis;
          display: block;
          overflow: hidden;
        }
      }
    }
  }
}
</style>
